/**
 * Карусельки
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */



function mainSliders() {
    let $sliders = $('.mainslider');
    if ($sliders.length) {
        $sliders.each(function(i, e) {
            let $slider = $(e);
            let $prev = $('.pager__prev', $slider);
            let $next = $('.pager__next', $slider);

            $slider.find('.ref-slider').slick({
                infinite : false,
                prevArrow: $prev,
                nextArrow: $next,
            });
        });
    }
}

export default mainSliders;
